import { isNilOrEmpty } from '@lucidlink/tscore';
import { InvalidArgumentError } from '#common/types';
import { createS3Config, createS3Store } from '#object-store/s3';
import { AWS_PROVIDER, ObjectStoreCredentialsKind, OTHER_PROVIDER, } from '#object-store/types';
import { DEFAULT_BUCKET_OBJECTS_LIMIT, MAX_BUCKET_OBJECTS_LIMIT, } from './types';
const FOLDER_DELIMITER = '/';
export class BucketObjectsHelper {
    tupleWasm;
    adminCrypto;
    constructor(tupleWasm, adminCrypto) {
        this.tupleWasm = tupleWasm;
        this.adminCrypto = adminCrypto;
    }
    async listObjects(dataStore, params) {
        const limit = params?.limit ?? DEFAULT_BUCKET_OBJECTS_LIMIT;
        if (limit < 1 || limit > MAX_BUCKET_OBJECTS_LIMIT) {
            throw new InvalidArgumentError(`Limit must be between 1 and ${MAX_BUCKET_OBJECTS_LIMIT}`);
        }
        const store = await this.createStore(dataStore);
        try {
            const page = await store.listObjects(dataStore.bucketName, BucketObjectsHelper.buildListObjectsParams(limit, params));
            return BucketObjectsHelper.toListObjectsResult(page);
        }
        finally {
            store.stop();
        }
    }
    static buildListObjectsParams(limit, params = {}) {
        const listObjectsParams = { delimiter: FOLDER_DELIMITER, maxKeys: limit };
        const { prefix, cursor } = params;
        if (!isNilOrEmpty(prefix)) {
            listObjectsParams.prefix = prefix;
        }
        if (!isNilOrEmpty(cursor)) {
            listObjectsParams.continuationToken = cursor;
        }
        return listObjectsParams;
    }
    static toListObjectsResult(page) {
        const result = {
            items: page.objects.map((object) => ({
                key: object.key,
                size: object.size,
                lastModified: object.lastModTime,
                isFolder: object.isFolder,
            })),
        };
        if (!isNilOrEmpty(page.nextContinuationToken)) {
            result.nextCursor = page.nextContinuationToken;
        }
        return result;
    }
    async createStore(dataStore) {
        const secretKey = await this.decrypt(dataStore.adminEncryptedSecretKey);
        return createS3Store(createS3Config({
            provider: isNilOrEmpty(dataStore.endpointOverride) ? AWS_PROVIDER : OTHER_PROVIDER,
            credentials: {
                kind: ObjectStoreCredentialsKind.IAM,
                accessKey: dataStore.accessKey,
                secretKey,
            },
            httpScheme: dataStore.httpScheme,
            region: dataStore.region,
            endpointOverride: dataStore.endpointOverride,
            useVirtualAddressing: dataStore.useVirtualAddressing,
        }));
    }
    async decrypt(adminEncryptedSecretKey) {
        const decryptedTuple = await this.adminCrypto.decrypt(adminEncryptedSecretKey);
        return this.tupleWasm.getStringFromTuple(decryptedTuple);
    }
}
